import getIn from 'transmute/getIn';
export const getCurrentInbox = getIn(['unifiedInbox', 'currentInbox']);